import { render, staticRenderFns } from "./MainSite.vue?vue&type=template&id=96a7a386&scoped=true&"
import script from "./MainSite.vue?vue&type=script&lang=js&"
export * from "./MainSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a7a386",
  null
  
)

export default component.exports